import { takeEvery, put, call, fork, delay } from 'redux-saga/effects';
import { Client } from '../../utils/client';
import {
  SEARCH_ON_LOAD, searchOnLoadSuccess, SEARCH_FILTER, searchFilterSuccess,
  SEARCH_DETAILS, searchDetailsSuccess, searchError,
  RETRIEVE_MTCN, retrieveMtcnSuccess, transactionQuerySuccess, transactionQueryFailure, TRANSACTION_QUERY
} from './actions';
import { appLogout } from '../../redux-root/actions';

export function* searchOnLoad(action) {
  try {
    const data = yield call(Client.getData, '/api/v1/products/helperlist');

    const receivingCountriesData= yield call(Client.getData, "/api/v1/utility/receivingcountries");

    const statusData = yield call(Client.getData, '/api/v1/remittances/transactions/status');

    const paymentModesData = yield call(Client.getData, '/api/v2/products/source-of-funds', true);

    data.statusData = statusData;
    data.receivingCountriesData= receivingCountriesData
    data.paymentModesData = paymentModesData
    yield put(searchOnLoadSuccess(data));
  } catch (error) {
    console.log(error);
    yield put(searchError(error))
    if (error.status === 401) {
      yield put(appLogout(true));
    }
  }
}

export function* searchFilter(action) {
  const paramObject = Object.assign({}, action.payload);

  let params = '';

  if (paramObject.transactionId) {
    params = `transactionId=${paramObject.transactionId}`;
  } else if (paramObject.partnerTransactionIdCheck) {
    params = `partnerTransactionIdCheck=${paramObject.partnerTransactionIdCheck}`;
  } else {
    Object.keys(paramObject).forEach(key => {
      if (params) {
        params += `&${key}=${paramObject[key]}`;
      } else {
        params += `${key}=${paramObject[key]}`;
      }
    });
  }

  // console.log(params);

  try {
    const data = yield call(Client.getData, `/api/v1/remittances/list?${params}`);

    yield put(searchFilterSuccess(data));
  } catch (error) {
    console.log(error);
    yield put(searchError(error))
    if (error.status === 401) {
      yield put(appLogout(true));
    }
  }
}

export function* searchDetails(action) {
  const id = action.payload;

  try {
    const data = yield call(Client.getData, `/api/v1/remittances/details/${id}`);

    yield put(searchDetailsSuccess(data));
  } catch (error) {
    console.log(error);
    yield put(searchError(error))
    if (error.status === 401) {
      yield put(appLogout(true));
    }

  }
}

export function* retrieveMtcn(action) {
  const id = action.payload;

  console.log('Saga retrieveMtcn:', action)
  try {
    const data = yield call(Client.getData, `/api/v1/remittances/transactions/${id}/mtcn`);

    yield put(retrieveMtcnSuccess(data.mtcn));
  } catch (error) {
    console.log(error);
    yield put(searchError(error))
    if (error.status === 401) {
      yield put(appLogout(true));
    }

  }
}

export function* transactionQuery(action) {
  const id = action.payload.id;

  console.log('transaction id:', id)
  try {
    const data = yield call(Client.getData, `/api/v2/remittances/transactions/${id}/query`);
    yield put(transactionQuerySuccess(data));
  } catch (error) {
    console.log(error);
    yield put(transactionQueryFailure(error))
    if (error.status === 401) {
      yield put(appLogout(true));
    }

  }
}


function* watchSearchOnLoad() {
  yield takeEvery(SEARCH_ON_LOAD, searchOnLoad);
}

function* watchSearchFilter() {
  yield takeEvery(SEARCH_FILTER, searchFilter);
}

function* watchSearchDetails() {
  yield takeEvery(SEARCH_DETAILS, searchDetails);
  yield takeEvery(RETRIEVE_MTCN, retrieveMtcn);
  yield takeEvery(TRANSACTION_QUERY, transactionQuery);
}

export function* searchSaga() {
  yield fork(watchSearchOnLoad);
  yield fork(watchSearchFilter);
  yield fork(watchSearchDetails);
}
